import Call from "../../../hocs/call";
import EnhancedTree from "../../../components/enhanced-tree";
import {getUrnFromArtefact, SDMX_JSON_DATAFLOW_URN_NAMESPACE} from "../../../utils/sdmxJson";
import {getNodes, UNCATEGORIZED_CATEGORY_CODE} from "../../../utils/tree";
import {getLocalizedStr} from "../../../middlewares/i18n/utils";
import React from "react";
import {
  categoriseCategorySchemesAndDataflowsDataflow,
  changeCategorySchemesAndDataflowsLanguage,
  deleteCategorySchemesAndDataflowsDataflowCategorisation,
  setToCategorizeDataflow,
  readCategorySchemesAndDataflowsTree,
  addCategorisationToDataflow,
  reorderCategoryScheme,
  updateOrderCategoryScheme
} from "./actions";
import {Modal} from "antd";
import "./style.css"
import {categorisationsSorterFactory} from "./utils";
import {connect} from "react-redux";
import {compose} from "redux";
import {translate} from "react-i18next";
import { BUTTON_CLONE, BUTTON_PASTE } from "../../../styles/buttons";
import _ from "lodash";

const mapStateToProps = (state) => ({
  username: state.app.user.username,
  permissions: state.app.user.permissions,
  tree: state.scenes.metaManager.categorySchemesAndDataflows.tree,
  categorySchemesOriginal: state.scenes.metaManager.categorySchemesAndDataflows.categorySchemes,
  refreshCategorySchemes: state.scenes.metaManager.categorySchemesAndDataflows.refreshCategorySchemes,
  categorisations: state.scenes.metaManager.categorySchemesAndDataflows.categorisations,
  toCategorizeDataflow: state.scenes.metaManager.categorySchemesAndDataflows.toCategorizeDataflow,
  nodeId: state.app.endpointId,
  nodes: state.config.nodes,
  appLanguage: state.app.language,
  dataLanguages: state.config.dataManagement.dataLanguages,
  categorySchemes: state.middlewares.defaultCategorySchemeSelector.categorySchemeDetail
});

const mapDispatchToProps = dispatch => ({
  fetchTree: (lang, categorySchemePermissions, username) => dispatch(readCategorySchemesAndDataflowsTree(lang, categorySchemePermissions, username)),
  onDataflowCategorize: (dataflow, categoryUrn, categorisations, to, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t) =>
    dispatch(categoriseCategorySchemesAndDataflowsDataflow(dataflow, categoryUrn, categorisations, to, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t)),
  onDeleteDataflowCategorisation: (dataflow, categorisations) =>
    dispatch(deleteCategorySchemesAndDataflowsDataflowCategorisation(dataflow, categorisations)),
  onLanguageChange: () => dispatch(changeCategorySchemesAndDataflowsLanguage()),
  onSetToCategorizeDataflow : (dataflow) => dispatch(setToCategorizeDataflow(dataflow)),
  onAddCategorisationToDataflow : (dataflow, categoryUrn, orderAnnotationType, lang, to, toSisterDfOrderedCategorisations, agencyPermissions, t) => 
    dispatch(addCategorisationToDataflow(dataflow, categoryUrn, orderAnnotationType, lang, to, toSisterDfOrderedCategorisations, agencyPermissions, t)),
  onReorderCategorySchemes: (dragNode, tree, annotationsOrder) => dispatch(updateOrderCategoryScheme(dragNode, tree, annotationsOrder))
});

const onDrop = (ev, onDataflowCategorize, categorisations, t, lang, orderAnnotationType, agencyPermissions, tree, onReorderCategorySchemes, categorySchemes, categorySchemesOrderAnnotation) => {
  const draggedInto = ev.node.props["data-node"];
  
  if (ev.dragNode.props["data-node"].type === "dataflow") {

    const dataflow = ev.dragNode.props["data-node"];

    const pos = ev.node.props.pos.split('-');
    const dropPos = ev.dropPosition - Number(pos[pos.length - 1]);

    let fromSisterDfOrderedCategorisations =
      categorisations
        .filter(({source, target}) =>
          source.includes(SDMX_JSON_DATAFLOW_URN_NAMESPACE) &&
          target === dataflow.categoryUrn
        )
        .sort(categorisationsSorterFactory(orderAnnotationType, lang));
    const toSisterDfOrderedCategorisations =
      categorisations
        .filter(({source, target}) =>
          source.includes(SDMX_JSON_DATAFLOW_URN_NAMESPACE) &&
          (target === (ev.dropToGap ? draggedInto.categoryUrn : draggedInto.urn))
        )
        .sort(categorisationsSorterFactory(orderAnnotationType, lang));

    const from = fromSisterDfOrderedCategorisations.map(({source}) => source).indexOf(dataflow.urn);
    let to = toSisterDfOrderedCategorisations.map(({source}) => source).indexOf(draggedInto.urn);

    if (ev.dropToGap) {

      if (draggedInto.categoryUrn === dataflow.categoryUrn) {

        // same category

        fromSisterDfOrderedCategorisations = [];

        to = from < to
          ? dropPos < 0 // moving forward into the array
            ? to - 1 // dropPos = -1 => drag on top node gap
            : to // dropPos = 1 => drag on bottom node gap
          : dropPos < 0 // moving backwards into the array
            ? to // dropPos = -1 => drag on top node gap
            : to + 1; // dropPos = 1 => drag on bottom node gap
        if (to === -1) {
          to = 0
        }
        if (to === toSisterDfOrderedCategorisations.length + 1) {
          to = toSisterDfOrderedCategorisations.length
        }

      } else {

        // other category

        if (toSisterDfOrderedCategorisations.find(({source}) => source === getUrnFromArtefact(dataflow))) {
          Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.duplicateCategorisation.title")});
          return;
        }

        to = dropPos < 0 // moving backwards into the array
          ? to // dropPos = -1 => drag on top node gap
          : to + 1; // dropPos = 1 => drag on bottom node gap;
        if (to === -1) {
          to = 0
        }
        if (to === toSisterDfOrderedCategorisations.length + 1) {
          to = toSisterDfOrderedCategorisations.length
        }
      }

      draggedInto.categoryUrn
        ? onDataflowCategorize(dataflow, draggedInto.categoryUrn, categorisations, to, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t)
        : Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.notValidCategory.title")});

    } else if (draggedInto.urn && draggedInto.type === "category") {

      if (toSisterDfOrderedCategorisations.find(({source}) => source === getUrnFromArtefact(dataflow))) {
        Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.duplicateCategorisation.title")});
      } else {
        onDataflowCategorize(dataflow, draggedInto.urn, categorisations, 0, fromSisterDfOrderedCategorisations, toSisterDfOrderedCategorisations, lang, orderAnnotationType, agencyPermissions, t)
      }

    } else {
      Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.notValidCategory.title")});
    }
  } else if (ev.dragNode.props["data-node"].type === "categoryscheme") {
    const categoryScheme = categorySchemes.filter((categoryScheme) => categoryScheme.id === ev.dragNode.props["data-node"].id)[0];
    const indexOfDroppedTo = categorySchemes.findIndex(({id}) => id === draggedInto.id )

    const newTree = categorySchemes.filter((item) => item.id !== categoryScheme.id)
    newTree.splice(indexOfDroppedTo, 0, categoryScheme)
    const orderedTree = newTree.map(function(item, index) {
      const annotations = item.annotations ? item.annotations.filter(annotation => annotation.id !== categorySchemesOrderAnnotation.id) : []
      const orderAnnotation = item.annotations ? item.annotations.filter(annotation => annotation.id === categorySchemesOrderAnnotation.id) : []
      const newOrderTexts =  {[lang]: (index+1).toString()};
      var orderTexts = newOrderTexts;
      if(orderAnnotation.length > 0) {
        orderTexts = _.merge(orderAnnotation[0].texts, newOrderTexts);
      }
      return {
        ...item,
         annotations:
          [
            ...annotations, {id: categorySchemesOrderAnnotation.id, type: categorySchemesOrderAnnotation.type, texts: orderTexts}
          ]
        }
      })
    onReorderCategorySchemes(orderedTree)
  } else {
    Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.canDragOnlyCategorySchemesAndDataflow.title")});
  }
};

const onPasteDataflowIntoCategory = (
  onAddCategorisationToDataflow,
  dataflow,
  toCategoryNode,
  categorisations,
  orderAnnotationType,
  lang, 
  agencyPermissions,
  t
) => {
 
  const toSisterDfOrderedCategorisations =
    categorisations
      .filter(({source, target}) =>
        source.includes(SDMX_JSON_DATAFLOW_URN_NAMESPACE) &&
        target === toCategoryNode.urn
      ).sort(categorisationsSorterFactory(orderAnnotationType, lang));

  if (toSisterDfOrderedCategorisations.find(({source}) => source === getUrnFromArtefact(dataflow))) {
    Modal.error({title: t("scenes.metaManager.categorySchemesDataflowsTree.errors.duplicateCategorisation.title")});
  } else {
    onAddCategorisationToDataflow(dataflow, toCategoryNode.urn, orderAnnotationType, lang, 0, toSisterDfOrderedCategorisations, agencyPermissions, t)
  }     
}

const CategorySchemesAndDataflows = ({
                                       t,
                                       username,
                                       permissions,
                                       tree,
                                       categorisations,
                                       toCategorizeDataflow,
                                       nodes,
                                       nodeId,
                                       appLanguage,
                                       dataLanguages,
                                       fetchTree,
                                       onDataflowCategorize,
                                       onDeleteDataflowCategorisation,
                                       onLanguageChange,
                                       onSetToCategorizeDataflow,
                                       onAddCategorisationToDataflow,
                                       onReorderCategorySchemes,
                                       categorySchemes,
                                       categorySchemesOriginal,
                                       refreshCategorySchemes,
                                     }) => {

  const orderAnnotationType = nodes.find(node => node.general.id === nodeId).annotations.categorisationsOrder.type;

  const categorySchemesOrderAnnotation = nodes.find(node => node.general.id === nodeId).annotations.layoutCategorySchemesOrder;
  
  const categorySchemePermissions = permissions ? permissions.categoryScheme : [];

  const draggableTree = username !== null ? true : false

  return (
    <Call
      cb={() => fetchTree(appLanguage, categorySchemePermissions, username)}
      disabled={!(nodes && nodes.length > 0 && tree === null && refreshCategorySchemes !== false && (username === null || username !== null && permissions !== null))}
    >
      <Call
        cb={onLanguageChange}
        cbParam={appLanguage}
        checkCbParamChangeOnly
        disableFirst
      >
        <div className="category-schemes-and-dataflows__categorisation__tree">
          <EnhancedTree
            tree={tree}
            getNodeKey={node => node.id === UNCATEGORIZED_CATEGORY_CODE ? UNCATEGORIZED_CATEGORY_CODE : getUrnFromArtefact(node)}
            childrenKey="categories"
            idKey="id"
            nameKey="name"
            catIdKey="id"
            catNameKey="name"
            defaultCollapsed
            getFilter={
              searchText =>
                ({id, name}) => {
                  const search = searchText.toLowerCase();
                  return (id && id.toLowerCase()
                      .indexOf(search) >= 0) ||
                    getLocalizedStr(name, appLanguage, dataLanguages)
                      .toLowerCase()
                      .indexOf(search) >= 0;
                }
            }
            hiddenIdKeys={[UNCATEGORIZED_CATEGORY_CODE]}
            icon="file-text"
            getIconColor={() => "#37a0f4"}
            treeActions={[
              {
                title: t('scenes.metaManager.categorySchemesDataflowsTree.tree.refreshButton.title'),
                icon: 'sync',
                onClick: () => fetchTree(appLanguage, categorySchemePermissions, username)
              }
            ]}
            draggable={draggableTree}
            unselectableKeys={[
              ...getNodes(tree, 'categories', () => true)
                .map(node =>
                  node.id === UNCATEGORIZED_CATEGORY_CODE ? UNCATEGORIZED_CATEGORY_CODE : getUrnFromArtefact(node)
                )
            ]}
            onDrop={ev => onDrop(ev, onDataflowCategorize, categorisations, t, appLanguage, orderAnnotationType, permissions ? permissions.agencies : [], tree, onReorderCategorySchemes, categorySchemesOriginal, categorySchemesOrderAnnotation)}
            rightClickActions={[
              node => (node.type === "dataflow" && node.categoryUrn)
                ? ({
                    icon: 'disconnect',
                    title: t('scenes.metaManager.categorySchemesDataflowsTree.tree.actions.deleteCategorisation.title'),
                    onClick: () => onDeleteDataflowCategorisation(node, categorisations)
                  })
                : null,
              node => (node.type === "dataflow" && node.categoryUrn)
                ? ({
                  ...BUTTON_CLONE,
                  title: t('scenes.metaManager.categorySchemesDataflowsTree.tree.actions.duplicateCategorisation.title'),
                  onClick: () => onSetToCategorizeDataflow(node)
                })
                : null,
                node => (node.type === "category" && toCategorizeDataflow)
                ? ({
                  ...BUTTON_PASTE,
                  title: t('scenes.metaManager.categorySchemesDataflowsTree.tree.actions.pasteCategorisation.title'),
                  onClick: () => onPasteDataflowIntoCategory(onAddCategorisationToDataflow, toCategorizeDataflow, node, categorisations, orderAnnotationType, appLanguage, permissions ? permissions.agencies : [], t) 
                })
                : null,
            ]}
          />
        </div>
      </Call>
    </Call>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(CategorySchemesAndDataflows);

